<template>
  <div class="activity-card">
    <div class="head">
      <div class="title">
        <span>活动报名</span><span class="order-num">（{{ orderNum }}）</span>
      </div>
      <div class="status">已报名</div>
    </div>
    <div class="body" @click="goActivityAction">
      <div class="body-left">
        <div class="activity-name">{{ activityTitle }}</div>
        <div v-if="subActivities == null || subActivities.length === 0" class="activity-people">
          参加人数：{{ participantNumber }}人
        </div>

        <template v-else>
          <div
            v-for="(item, index) in subActivities"
            :key="index"
            class="activity-people"
          >
            {{ item.title }} | 参加人数：{{ item.participants }}人
          </div>
        </template>
      </div>

      <img v-if="!isList" class="arrow-right" src="@/assets/images/arrow_right.png" />
    </div>
    <div v-if="!isList" class="foot">下单时间：{{ orderTime }}</div>
  </div>
</template>
<script>
import { TimeFormat } from "@/assets/js/utils";
export default {
    props: {
        order:{
            type: Object,
            default: null
        },
        isList: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
             activityId: null,
            orderNum: "",
            activityTitle: "",
            participantNumber: 0,
            orderTime: "",
            subActivities: null,
        }
    },
    mounted() {
        if(this.order!=null) this.initView()
    },
    watch: {
        order(order) {
            console.log(this.order)
            if(order!=null) {
                this.initView()
            }
        }
    },
  methods: {

    initView() {
      let { signUpCode, signUpTime, activity } = this.order;

      this.orderNum = signUpCode;
      this.orderTime = TimeFormat.timestampSecondToChinese(signUpTime);
      let { Id, title, subActivities } = activity;
      this.activityId = Id;
      this.activityTitle = title;
      if (subActivities == null || subActivities.length === 0) {
        // 单
        let { participants } = activity;

        this.participantNumber = participants;
      } else {
        this.subActivities = activity.subActivities;
      }
    },
    goActivityAction() {
        if(!this.isList) {
            this.$router.replace({
                name: 'ActivityDetail',
                params: {id: this.activityId}
            })
        }
    }
  },
};
</script>
<style lang="less" scoped>
.activity-card {
  background: #fff;
}
.head,
.body,
.foot {
  position: relative;
  padding-left: 16px;
  padding-right: 16px;
  &:after {
    position: absolute;
    box-sizing: border-box;
    content: " ";
    pointer-events: none;
    right: 16px;
    bottom: 0;
    left:16px;
    border-bottom: 1px solid #eeeeee;
    -webkit-transform: scaleY(0.5);
    transform: scaleY(0.5);
  }
}

.head {
  display: flex;
  align-items: center;
  height: 48px;
}
.title {
  flex: 1;
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
}
.order-num {
  font-size: 14px;
  font-weight: 400;
  color: #999999;
  line-height: 20px;
}
.status {
  font-size: 16px;
  font-weight: 400;
  color: #999999;
  line-height: 24px;
}

.body {
  display: flex;
  align-items: center;
  padding-top: 12px;
  padding-bottom: 12px;

  &-left {
    flex: 1;
  }
}
.arrow-right {
  width: 22px;
  height: 22px;
  margin-right: 16px;
}
.activity-name {
  color: #333333;
  line-height: 24px;
  font-size: 16px;
}
.activity-people {
  font-size: 14px;
  font-weight: 400;
  color: #999999;
  line-height: 20px;
}
.foot {
  line-height: 40px;
  color: #333333;

  font-size: 14px;
}
</style>